import React from 'react'
import { modal, ModalParams } from '@codeleap/modals'
import { APIClient } from '@/services'
import { SearchGlobal } from './Search'
import { LearnCard } from '../Learn'

export const LearnSearch = ({ toggle, onBack }: ModalParams) => {
  const [search, setSearch] = React.useState('')
  const { listProps } = APIClient.Learn.useLearnSearch(search)

  const renderModuleItem = React.useCallback(({ item }) => {
    if (!item?.id || !item?.title) {
      return null
    }

    return <LearnCard item={item} onPress={toggle} />
  }, [])

  return (
    <SearchGlobal
      onBack={onBack}
      listProps={listProps}
      renderCard={renderModuleItem}
      onSearch={setSearch}
      search={search}
    />
  )
}

export const LearnSearchModal = modal()
  .content(LearnSearch)
  .props({ variants: ['centered'], showClose: false })
